import type { ReactNode } from 'react';
import frAnkorstore from '@repo/visual-assets/illustrations/clients/fr/ankorstore.png';
import frBackmarket from '@repo/visual-assets/illustrations/clients/fr/backmarket.png';
import frMistralai from '@repo/visual-assets/illustrations/clients/fr/mistralai.png';
import frSkello from '@repo/visual-assets/illustrations/clients/fr/skello.png';
import frYuka from '@repo/visual-assets/illustrations/clients/fr/yuka.png';
import deBackmarket from '@repo/visual-assets/illustrations/clients/de/backmarket.png';
import deFinanzfluss from '@repo/visual-assets/illustrations/clients/de/finanzfluss.png';
import deGetir from '@repo/visual-assets/illustrations/clients/de/getir.png';
import deHive from '@repo/visual-assets/illustrations/clients/de/hive.png';
import deToogoodtogo from '@repo/visual-assets/illustrations/clients/de/toogoodtogo.png';
import styles from './customer-logos-bar.module.css';

interface Logo {
  id: string;
  name: string;
  url: string;
}

const CUSTOMER_LOGOS_PER_COUNTRY: Record<'FR' | 'DE', Logo[]> = {
  FR: [
    { id: 'backmarket', name: 'Back Market', url: frBackmarket },
    { id: 'mistralai', name: 'MistralAI', url: frMistralai },
    { id: 'yuka', name: 'Yuka', url: frYuka },
    { id: 'ankorstore', name: 'AnkorStore', url: frAnkorstore },
    { id: 'skello', name: 'Skello', url: frSkello },
  ],
  DE: [
    { id: 'toogoodtogo', name: 'Too Good To Go', url: deToogoodtogo },
    { id: 'getir', name: 'Getir', url: deGetir },
    { id: 'finanzfluss', name: 'Finanzfluss', url: deFinanzfluss },
    { id: 'hive', name: 'Hive', url: deHive },
    { id: 'backmarket', name: 'Back Market', url: deBackmarket },
  ],
};

interface CustomerLogosBarProps {
  country: 'FR' | 'DE';
}

// oxlint-disable-next-line typescript/no-useless-default-assignment
export function CustomerLogosBar({ country = 'FR' }: CustomerLogosBarProps): ReactNode {
  const logos = CUSTOMER_LOGOS_PER_COUNTRY[country];

  return (
    <div className={styles.logos} data-test-welcome-logos-bar>
      {logos.map(({ id, name, url }) => (
        <img alt={name} className={styles.logo} data-test-customer-logo={id} key={id} src={url} />
      ))}
    </div>
  );
}
